import { Moment } from 'moment';

export class CicoHelpConfigurationFile {
  filename: string;
  filesize: number;
  uploadedAt: Moment;
  uploadedBy: string;
  downloadUrl: string;

  public static fromDto(data: any): CicoHelpConfigurationFile {
    if (!data) {
      return null;
    }

    const result = new CicoHelpConfigurationFile();

    result.filename = data.filename;
    result.filesize = data.filesize;
    result.uploadedAt = data.uploaded_at;
    result.uploadedBy = data.uploaded_by;
    result.downloadUrl = data.download_url;

    return result;
  }
}
